export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_LOADING = 'FETCH_USER_LOADING'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'

export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_LOADING = 'UPDATE_USER_LOADING'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'
